import { LegalPageLayout, useLegalDocument } from "@/components/LegalPageLayout";

const PrivacyPolicy = () => {
  const document = useLegalDocument("privacy");
  return <LegalPageLayout document={document} />;
};

export default PrivacyPolicy;
